import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import officeIcon from '../../assets/img/icons/black-site-icon.svg';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import { TableItem } from '../../styledComponents/ProjectsNew';
import { PrimaryButton } from '../../styledComponents/buttons';
import {
  CommonFlex,
  CommonImage,
  CommonText,
  Container,
  InputField,
  TableText,
} from '../../styledComponents/common';
import { NoDataContainer } from '../FieldServices/JobSites/jobSitesStyles';
import { OfficeListTable } from './officesStyles';

const OfficeList = ({
  officesList,
  isLoading,
  searchTerm,
  onSearchTermChange,
  history,
}) => {
  const [list, setList] = useState([]);

  const { t } = useTranslation();

  useEffect(() => {
    if (officesList && officesList.length > 0) {
      setList(officesList);
    } else if (officesList && officesList.length === 0) {
      setList([]);
    }
  }, [officesList]);

  useEffect(() => {
    if (
      searchTerm &&
      searchTerm !== '' &&
      officesList &&
      officesList.length > 0
    ) {
      const originalList = JSON.parse(JSON.stringify(officesList));
      const filteredList = [];
      originalList.forEach(e => {
        if (
          searchTerm &&
          e.name.toLowerCase().indexOf(searchTerm.toLowerCase().trim()) === -1
        ) {
          return;
        }
        filteredList.push(e);
      });
      setList(filteredList);
    } else if (searchTerm === '') {
      setList(officesList);
    }
  }, [searchTerm]);

  const handleView = item => {
    item?.id && history.push(`/user/office-details?id=${item.id}`);
  };

  return (
    <div>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : officesList && officesList.length > 0 ? (
        <>
          <CommonFlex gap="6px" direction="column" alignItems="start">
            <CommonText name title fontSize="14px">
              {t('offices')}
            </CommonText>
            <InputField
              placeholder={t('search_office')}
              value={searchTerm}
              onChange={onSearchTermChange}
              width="300px"
            />
          </CommonFlex>
          <Container padding="0">
            <OfficeListTable heading>
              <TableItem>
                <TableText>{t('name')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('nationality')}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{t('number_of_pilgrims')}</TableText>
              </TableItem>
            </OfficeListTable>
            {list.map((item, index) => (
              <OfficeListTable key={index}>
                <TableItem>
                  <TableText>{item.name}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>{item.nationality}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>{item.pilgrims_number}</TableText>
                </TableItem>
                <TableItem>
                  <PrimaryButton onClick={() => handleView(item)}>
                    {t('view')}
                  </PrimaryButton>
                </TableItem>
              </OfficeListTable>
            ))}
          </Container>
        </>
      ) : (
        <NoDataContainer>
          <CommonImage src={officeIcon} alt="" size="35px" />
          <CommonText fontSize="15px" fontWeight="600" margin="20px 0 0">
            No Offices!
          </CommonText>
          <CommonText $label fontSize="13px" fontWeight="500" margin="15px 0 0">
            Add your very first office
          </CommonText>
          <PrimaryButton
            margin="30px 0 0"
            onClick={() => history.push('create-office')}
          >
            {t('create_office')}
          </PrimaryButton>
        </NoDataContainer>
      )}
    </div>
  );
};

export default OfficeList;
